"use strict";

exports.encode = require('./_encode');
exports.decode = require('./_decode');